export default {"src":"/_next/static/media/lightRain.1988f70f.svg","height":157,"width":157};